<template>
  <sdPageHeader title="Laporan Pembinaan Person Grade">
    <template #buttons>
      <a-space>
        <a-button type="primary" @click="goBack"> <left-outlined /> Kembali </a-button>
      </a-space>
    </template>
  </sdPageHeader>
  <Main>
    <sdCards headless>
      <!-- Employee Information Section -->
      <div class="employee-info-section">
        <div class="info-row">
          <div class="info-col">
            <div class="info-item">
              <div class="info-label">NIP</div>
              <div class="info-value">{{ employeeData.nip }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Nama Pegawai</div>
              <div class="info-value">{{ employeeData.namaPegawai }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">PeG</div>
              <div class="info-value">{{ employeeData.peg }}</div>
            </div>
          </div>
          <div class="info-col">
            <div class="info-item">
              <div class="info-label">Jabatan</div>
              <div class="info-value">{{ employeeData.jabatan }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Personal Area</div>
              <div class="info-value">{{ employeeData.personalArea }}</div>
            </div>
            <!-- <div class="info-item">
              <div class="info-label">PoG</div>
              <div class="info-value">{{ employeeData.pog }}</div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Proyeksi Jabatan Section -->
      <div class="section-container">
        <h3 class="section-title">Proyeksi Jabatan</h3>
        <div class="proyeksi-container">
          <div class="proyeksi-row">
            <div class="proyeksi-label">Sebutan Jabatan</div>
            <div class="proyeksi-value">{{ proyeksiData.sebutanJabatan }}</div>
          </div>
          <div class="proyeksi-row">
            <div class="proyeksi-label">PoG</div>
            <div class="proyeksi-value">{{ proyeksiData.pog }}</div>
          </div>
          <div class="proyeksi-row">
            <div class="proyeksi-label">Org Level 2</div>
            <div class="proyeksi-value">{{ proyeksiData.orgLevel2 }}</div>
          </div>
          <div class="proyeksi-row">
            <div class="proyeksi-label">Org Level 3</div>
            <div class="proyeksi-value">{{ proyeksiData.orgLevel3 }}</div>
          </div>
          <div class="proyeksi-row">
            <div class="proyeksi-label">Org Level 4</div>
            <div class="proyeksi-value">{{ proyeksiData.orgLevel4 }}</div>
          </div>
          <div class="proyeksi-row">
            <div class="proyeksi-label">Org Level 5</div>
            <div class="proyeksi-value">{{ proyeksiData.orgLevel5 }}</div>
          </div>
        </div>
      </div>

      <!-- Riwayat Pengajuan Section -->
      <div class="section-container">
        <h3 class="section-title">Riwayat Pengajuan</h3>
        <a-timeline>
          <a-timeline-item v-for="(item, index) in timelineData" :key="index" :color="getStatusColor(item.status)">
            <div class="timeline-header">
              <div class="timeline-date">{{ item.date }}</div>
              <div class="timeline-time">{{ item.time }}</div>
            </div>
            <div class="timeline-content">
              <div class="timeline-title">{{ item.title }}</div>
              <div class="timeline-description" v-html="item.description"></div>
              <div
                v-if="
                  pengajuanData &&
                    pengajuanData.status === 'disetujui_hc' &&
                    item.status === 'success' &&
                    item.title === 'Detail Persetujuan'
                "
                class="timeline-actions"
              >
                <a-button type="primary" size="small" @click="downloadAttachment"
                  ><download-outlined /> Download Dokumen</a-button
                >
              </div>
            </div>
          </a-timeline-item>
        </a-timeline>
      </div>
    </sdCards>

    <!-- Approval Modal -->
    <a-modal
      v-model:visible="approvalModalVisible"
      title="Konfirmasi Persetujuan"
      :footer="null"
      :closable="true"
      :maskClosable="false"
      @cancel="handleCancelApproval"
      class="approval-modal"
    >
      <div class="confirmation-content">
        <p>Apakah Anda yakin ingin menyetujui pengajuan pembinaan Person Grade ini?</p>
        <div v-if="hasHcAssessmentPermission" class="form-item">
          <div class="form-label">Catatan Persetujuan:</div>
          <a-textarea
            v-model:value="approvalNote"
            placeholder="Tambahkan catatan persetujuan (opsional)"
            :rows="4"
            :maxLength="500"
          />
        </div>
        <div v-if="hasHcAssessmentPermission" class="form-item">
          <div class="form-label">Unggah Dokumen Pendukung:</div>
          <a-upload
            v-model:fileList="approvalFiles"
            :beforeUpload="beforeUpload"
            :remove="handleRemoveFile"
            :maxCount="1"
          >
            <a-button> <upload-outlined /> Pilih File </a-button>
            <template #itemRender="{ file }">
              <div class="upload-item">
                <paper-clip-outlined />
                <span class="upload-filename">{{ file.name }}</span>
                <a-button type="text" danger @click="() => handleRemoveFile(file)">
                  <delete-outlined />
                </a-button>
              </div>
            </template>
          </a-upload>
          <div class="upload-hint">Format: PDF, DOC, DOCX, XLS, XLSX (Maks. 5MB)</div>
        </div>
        <div class="confirmation-buttons">
          <a-space>
            <a-button @click="handleCancelApproval">Batal</a-button>
            <a-button type="primary" @click="handleConfirmApproval" :loading="approvalLoading">
              Ya, Setujui
            </a-button>
          </a-space>
        </div>
      </div>
    </a-modal>

    <!-- Reject Modal -->
    <a-modal
      v-model:visible="rejectModalVisible"
      title="Konfirmasi Tinjau Ulang"
      :footer="null"
      :closable="true"
      :maskClosable="false"
      @cancel="handleCancelReject"
      class="reject-modal"
    >
      <div class="confirmation-content">
        <p>Apakah Anda yakin ingin menolak pengajuan pembinaan Person Grade ini?</p>

        <div class="form-item">
          <div class="form-label">Alasan Tinjau Ulang:</div>
          <a-textarea v-model:value="rejectReason" :rows="4" placeholder="Masukkan alasan tinjau ulang" />
        </div>

        <div class="confirmation-buttons" style="margin-top: 16px;">
          <a-space>
            <a-button @click="handleCancelReject">
              Batal
            </a-button>
            <a-button type="primary" warning @click="handleConfirmReject" :loading="rejectLoading">
              Ya, Tinjau Ulang
            </a-button>
          </a-space>
        </div>
      </div>
    </a-modal>
  </Main>
</template>

<script>
import { Main } from '../styled';
import assessmentApi from '@/api/assessment';
import { getItem } from '@/utility/localStorageControl';
import { formatDate } from '@/utility/formatDate';
import { Upload } from 'ant-design-vue';
import { generateTimelineDataUtil } from '@/utility/timelineUtils';
import { handleSessionExpired } from '@/utility/utility';

const ViewPage = {
  name: 'ReportDetail',
  components: {
    Main,
  },
  computed: {
    isApproved() {
      return this.employeeData.statusPengajuan && this.employeeData.statusPengajuan.toLowerCase().includes('disetujui');
    },
  },
  data() {
    // Get permissions from localStorage
    const permissions = getItem('permissions') || [];

    return {
      loading: false,
      approvalLoading: false,
      rejectLoading: false,
      approvalModalVisible: false,
      rejectModalVisible: false,
      rejectReason: '',
      canApprove:
        permissions.includes('approve 1 assessment') ||
        permissions.includes('approve 2 assessment') ||
        permissions.includes('approve hc assessment'),
      pengajuanId: this.$route.params.id,
      pengajuanData: null,
      employeeData: {
        nip: '',
        namaPegawai: '',
        peg: '',
        jabatan: '',
        pog: '',
        personalArea: '',
        statusPengajuan: '',
      },
      proyeksiData: {
        sebutanJabatan: '',
        pog: '',
        orgLevel2: '',
        orgLevel3: '',
        orgLevel4: '',
        orgLevel5: '',
      },
      timelineData: [],
      hasHcAssessmentPermission: false,
      approvalNote: '',
      approvalFiles: [],
    };
  },
  created() {
    // Get ID from route params
    this.pengajuanId = this.$route.params.id || null;
    // Fetch data when component is created
    this.fetchPengajuanData();
    this.checkHcAssessmentPermission();
  },
  methods: {
    fetchPengajuanData() {
      // Show loading state
      this.loading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Construct the API URL with the ID parameter and include related data
      const url = this.pengajuanId
        ? `my-pengajuan?id=${this.pengajuanId}&with=proyeksiJabatan,userAssessment,approverAtasan,approverBod1`
        : 'my-pengajuan?with=proyeksiJabatan,userAssessment,approverAtasan,approverBod1';

      // Fetch data from the API
      assessmentApi
        .get(url, { headers })
        .then(response => {
          if (response.data && response.data.data && response.data.data.data && response.data.data.data.length > 0) {
            // Get the first pengajuan from the response
            const pengajuan = response.data.data.data[0];
            this.pengajuanData = pengajuan;

            // Map API data to employee data format
            const userAssessment = pengajuan.user_assessment || {};
            this.employeeData = {
              nip: pengajuan.nip || userAssessment.nip || '',
              namaPegawai: userAssessment.name || '',
              peg: userAssessment.peg || '',
              jabatan: userAssessment.jabatan || '',
              pog: userAssessment.pog || '',
              personalArea: userAssessment.personal_area || '',
              statusPengajuan: pengajuan.status || '',
            };

            // Map API data to proyeksi data format
            const proyeksiJabatan = pengajuan.proyeksi_jabatan || {};
            this.proyeksiData = {
              sebutanJabatan: proyeksiJabatan.jabatan || '',
              pog: proyeksiJabatan.pog ? proyeksiJabatan.pog.toString() : '',
              orgLevel2: proyeksiJabatan.org_level_2 || '',
              orgLevel3: proyeksiJabatan.org_level_3 || '',
              orgLevel4: proyeksiJabatan.org_level_4 || '',
              orgLevel5: '', // Not provided in API response
            };

            // Generate timeline data based on pengajuan status
            this.generateTimelineData(pengajuan);
          } else {
            this.$message.error('Data pengajuan tidak ditemukan');
          }
        })
        .catch(error => {
          console.error('Error fetching pengajuan data:', error);
          this.$message.error('Gagal memuat data pengajuan');
          if (error.response && error.response.status === 401) {
            handleSessionExpired();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    formatDateSafe(date, format) {
      try {
        return formatDate(date, format);
      } catch (error) {
        console.error('Error formatting date:', error);
        // Return a fallback format
        if (date instanceof Date) {
          return date.toLocaleDateString('id-ID');
        }
        return '';
      }
    },

    generateTimelineData(pengajuan) {
      try {
        this.timelineData = generateTimelineDataUtil(pengajuan, this.employeeData, this.formatDateSafe);
      } catch (error) {
        console.error('Error generating timeline data:', error);
        this.timelineData = [];
      }
    },

    goBack() {
      this.$router.push('/assessment/reporting');
    },

    getStatusColor(status) {
      const statusColors = {
        success: 'green',
        processing: 'blue',
        default: 'gray',
        error: 'red',
      };
      return statusColors[status] || 'blue';
    },

    async checkApprovalPeriod() {
      try {
        const token = getItem('access_token');
        const response = await assessmentApi.get('/check-approval-period', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        return response.data.is_approval_period;
      } catch (error) {
        if (error.response?.status === 401) {
          this.$message.error('Sesi anda telah berakhir, silahkan login kembali');
        } else {
          this.$message.error('Gagal memeriksa periode approval');
        }
        return false;
      }
    },

    async showApprovalModal() {
      const isApprovalPeriod = await this.checkApprovalPeriod();
      if (!isApprovalPeriod) {
        this.$message.warning('Maaf, saat ini belum masa approval');
        return;
      }
      this.approvalModalVisible = true;
    },

    async showRejectModal() {
      const isApprovalPeriod = await this.checkApprovalPeriod();
      if (!isApprovalPeriod) {
        this.$message.warning('Maaf, saat ini belum masa approval');
        return;
      }
      this.rejectModalVisible = true;
      this.rejectReason = '';
    },

    handleCancelApproval() {
      this.approvalModalVisible = false;
      // Reset form data
      if (this.hasHcAssessmentPermission) {
        this.approvalNote = '';
        this.approvalFiles = [];
      }
    },

    handleCancelReject() {
      this.rejectModalVisible = false;
      this.rejectReason = '';
    },

    handleConfirmApproval() {
      if (!this.pengajuanData || !this.pengajuanData.id) {
        this.$message.error('Data pengajuan tidak valid');
        return;
      }

      this.approvalLoading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Prepare data for submission
      const postData = {
        status: 'approved',
      };

      // Handle file uploads if user has HC assessment permission and uploaded files
      if (this.hasHcAssessmentPermission && this.approvalFiles.length > 0) {
        // Create form data for file upload
        const formData = new FormData();

        // Add file to form data (only one file allowed)
        if (this.approvalFiles.length > 0) {
          formData.append('pengajuan_assessment_id', this.pengajuanId);
          formData.append('catatan', this.approvalNote.trim());
          formData.append('attachment_type', 'hc');
          formData.append('file', this.approvalFiles[0].originFileObj);
        }

        // Submit form data to the API
        assessmentApi
          .post(`assessment-file`, formData, {
            headers: {
              ...headers,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$message.success('Pengajuan berhasil disetujui dengan dokumen pendukung!');
            this.approvalModalVisible = false;
            this.$router.push({ name: 'approval' });
          })
          .catch(error => {
            console.error('Error updating application with files:', error);
            this.$message.error('Gagal memperbarui pengajuan. Silakan coba lagi.');
          })
          .finally(() => {
            this.approvalLoading = false;
          });
      } else {
        // Submit data to the API as an update to existing resource (without files)
        assessmentApi
          .put(`pengajuan-assessment/${this.pengajuanId}`, postData, { headers })
          .then(() => {
            this.$message.success('Pengajuan berhasil disetujui!');
            this.approvalModalVisible = false;
            this.$router.push({ name: 'approval' });
          })
          .catch(error => {
            console.error('Error updating application:', error);
            this.$message.error('Gagal memperbarui pengajuan. Silakan coba lagi.');
          })
          .finally(() => {
            this.approvalLoading = false;
          });
      }
    },

    handleConfirmReject() {
      if (!this.pengajuanData || !this.pengajuanData.id) {
        this.$message.error('Data pengajuan tidak valid');
        return;
      }

      if (!this.rejectReason.trim()) {
        this.$message.warning('Alasan tinjau ulang harus diisi');
        return;
      }

      this.rejectLoading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Prepare the data for the API call
      const postData = {
        status: 'rejected',
        alasan_tinjau_ulang: this.rejectReason.trim(),
      };

      // Submit the rejection to the API
      assessmentApi
        .put(`pengajuan-assessment/${this.pengajuanId}`, postData, { headers })
        .then(() => {
          this.$message.success('Tinjau ulang berhasil diproses!');
          this.rejectModalVisible = false;
          this.rejectReason = '';
          this.$router.push({ name: 'approval' });
        })
        .catch(error => {
          console.error('Error processing rejection:', error);
          this.$message.error('Gagal memproses tinjau ulang');
        })
        .finally(() => {
          this.rejectLoading = false;
        });
    },

    checkHcAssessmentPermission() {
      // Get permissions from localStorage
      const permissions = getItem('permissions') || [];
      this.hasHcAssessmentPermission = permissions.includes('approve hc assessment');
    },

    downloadAttachment() {
      if (!this.pengajuanData || !this.pengajuanData.id) {
        this.$message.error('Data pengajuan tidak valid');
        return;
      }

      // Get access token from localStorage
      const accessToken = getItem('access_token');
      if (!accessToken) {
        this.$message.error('Sesi anda telah berakhir, silahkan login kembali');
        return;
      }

      // Get the file ID from the pengajuan data
      const pengajuanId = this.pengajuanData.id;

      // Set loading state
      this.$message.loading('Mempersiapkan dokumen untuk diunduh...', 0);

      // Use axios directly to get the file with proper headers
      assessmentApi
        .get(`assessment-file/${pengajuanId}/download`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          responseType: 'blob', // Important for file downloads
        })
        .then(response => {
          // Create a blob URL from the response
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);

          // Create a temporary link element to trigger the download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `dokumen_pengajuan_${pengajuanId}.pdf`);
          document.body.appendChild(link);

          // Trigger the download and clean up
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          this.$message.destroy();
          this.$message.success('Dokumen berhasil diunduh');
        })
        .catch(error => {
          console.error('Error downloading file:', error);
          this.$message.destroy();
          this.$message.error('Gagal mengunduh dokumen. Silakan coba lagi.');
        });
    },

    beforeUpload(file) {
      // Check file type
      const isValidType = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(file.type);
      if (!isValidType) {
        this.$message.error('Format file tidak didukung. Gunakan PDF, DOC, DOCX, XLS, atau XLSX.');
      }

      // Check file size (5MB max)
      const isLessThan5MB = file.size / 1024 / 1024 < 5;
      if (!isLessThan5MB) {
        this.$message.error('Ukuran file tidak boleh melebihi 5MB.');
      }

      // Return false to prevent auto-upload and add file to fileList if valid
      return isValidType && isLessThan5MB ? false : Upload.LIST_IGNORE;
    },

    handleRemoveFile(file) {
      const index = this.approvalFiles.indexOf(file);
      const newFileList = this.approvalFiles.slice();
      newFileList.splice(index, 1);
      this.approvalFiles = newFileList;
    },
  },
};

export default ViewPage;
</script>

<style scoped>
.employee-info-section {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
}

.info-col {
  flex: 1;
  min-width: 300px;
}

.info-item {
  margin-bottom: 12px;
}

.info-label {
  font-size: 14px;
  color: #8c8c8c;
  margin-bottom: 4px;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
}

.section-container {
  margin-bottom: 32px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  color: #262626;
}

.proyeksi-container {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
}

.proyeksi-row {
  display: flex;
  margin-bottom: 12px;
}

.proyeksi-label {
  width: 150px;
  font-size: 14px;
  color: #8c8c8c;
}

.proyeksi-value {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
}

.timeline-header {
  display: flex;
  margin-bottom: 8px;
}

.timeline-date {
  font-weight: 500;
  margin-right: 8px;
}

.timeline-time {
  color: #8c8c8c;
}

.timeline-content {
  margin-bottom: 16px;
}

.timeline-title {
  font-weight: 500;
  margin-bottom: 4px;
}

.timeline-description {
  color: #595959;
  line-height: 1.5;
}

.floating-action-buttons {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 100;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 8px;
}

.upload-hint {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 8px;
}

.upload-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.upload-filename {
  margin-left: 8px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approve-button {
  background-color: #52c41a !important;
  border-color: #52c41a !important;
  font-weight: 500;
  padding: 0 20px;
  height: 40px;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.reject-button {
  background-color: #fa8c16 !important;
  border-color: #fa8c16 !important;
  font-weight: 500;
  padding: 0 20px;
  height: 40px;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>
